module.exports = __webpack_public_path__ + "static/23-468f194156be665b2b14a2fc52122825.jpg";